import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";

import { AwsIntegrationView } from "../../../useSearchCloudIntegrations/gql";

const IntegrationsAwsTableSpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AwsIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={item.spaceDetails.id} fallbackName={item.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default IntegrationsAwsTableSpaceCell;
